/** yyyy-MM-dd helpers, local time, with no library. */

export const localDateKey = (d: Date = new Date()): string => {
    const pad = (n: number): string => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const addDaysKey = (key: string, days: number): string => {
    const [y, m, d] = key.split('-').map(Number);
    const date = new Date(y, m - 1, d + days);
    return localDateKey(date);
};

/** '2026-10-21' → '21 Oct'. */
export const dayLabel = (key: string | null | undefined): string => {
    if (!key) return '—';
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

/** A place-by date as the planner reads it: "today" when it is today or already past. */
export const whenLabel = (key: string | null | undefined, today: string): string => (key ? (key <= today ? 'today' : dayLabel(key)) : '—');

export const monthStartKey = (key: string): string => `${key.slice(0, 7)}-01`;

export const monthEndKey = (key: string): string => {
    const [y, m] = key.split('-').map(Number);
    return localDateKey(new Date(y, m, 0));
};
